<template>
  <div class="card-item" @click="goto(useritem)">
    <img :src="'/static/images/logo/'+useritem.lottery_type+'.jpeg '" alt v-if="useritem.lottery_type==17"/>
    <img :src="'/static/images/logo/19.png'" alt v-else-if="useritem.lottery_type==15"/>
    <img :src="'/static/images/logo/'+useritem.lottery_type+'.png '" alt v-else/>
    <p style="margin-left:5px" class="award-wrap" :class="'number' + (useritem.category==3?1:3)"><span style="display: block;margin-bottom:5px;">{{useritem.lottery_name}}</span>
      <ul class="lh_num_record">
        <li class="item lh_item" v-for="(item, index) in useritem.draw" :key="'re' + index" v-if="index<=6">
          <span class="numberft" :class="filterNumberColorFt(index,item)" v-if="useritem.lottery_type==19">{{item}}</span>
          <span class="numberlhc" :class="filterNumberColor(item)" v-else>{{item}}</span>
        </li>
      </ul>
      <span style="color:#999;font-size:12px;display: block;margin-top:2px">{{useritem.last_period}}</span>
    </p>
    <p class="info" v-if="useritem.period=='closed'">
      <span class="f-s12">未开盘</span>
    </p>
    <p class="info" v-else>
      <span class="f-s12">{{useritem.period}}期</span>
      <span class="f-s12" v-if="useritem.countdown<0">
        已封盘
      </span>
      <span class="f-s12" v-else>
        距开奖：
        <i>{{minutes || ''}} : {{seconds || ''}}</i>
      </span>
    </p>
  </div>
</template>

<script>
import { format, countdown } from "../../../../utils/time";
import { filterNumber } from "../../../../utils/lhMethods";
import { getDownCount } from "@/service/lottery";
export default {
  name: "card-item",
  props: {
    item: {
      type: Object,
      default() {
        return {
          img: "",
          name: "",
          number: "",
          target: ""
        };
      }
    }
  },
  data() {
    return {
      seconds: "",
      minutes: "",
      useritem: this.item
    };
  },
  methods: {
      // 过滤当前number的背景图片颜色
      filterNumberColor(checkNumber) {
        const isFilterNumber = filterNumber(checkNumber);
        if (isFilterNumber) {
          return isFilterNumber;
        }
        return '';
      },
      filterNumberColorFt(index,checkNumber) {
        if(index!=0){
          return 'number-'+checkNumber;
        }
      },
      goto(item){
          this.$router.push({path:'/home/hall',query: item})
      },

    countdown() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.useritem.countdown < 0) {
          //this.getResult();
        } else {
          this.useritem.countdown--;
          let countd = this.useritem.countdown;
          let minutes = parseInt(countd / 60);
          let seconds = Math.floor(countd - minutes * 60) + 1;
          minutes = minutes < 0 ? 0 : minutes;
          seconds = seconds < 0 ? 0 : seconds;
          if (minutes == 0 && seconds == 0) {
              this.minutes = '';
              this.seconds = '';
          } else {
            this.minutes = minutes < 10 ? "0" + minutes : minutes;
            this.seconds = seconds < 10 ? "0" + seconds : seconds;
          }
        }
      }, 1000);
    },
    async getResult() {
      let item = await getDownCount(this.useritem.lottery_type);
      //console.log(item);
      this.useritem = item[0];
    }
  },

  mounted() {
    this.countdown();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="less">
.card-item {
  color: #464646;
  display: flex;
  padding: 30px 5px 30px 5px;
  font-size: 32px;
  background: #fff;
  box-sizing: border-box;
  align-items: center;
  border-radius: 6px;
  > img {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background-color: orangered;
  }
  > .name {
    flex: 1;
    margin-top: 10px;
    align-self: flex-start;
    flex-shrink: 0;
    margin-left: 50px;
  }
  > .info {
    flex: 1;
    color: #999;
    height: 86px;
    display: flex;
    text-align: right;
    flex-direction: column;
    justify-content: space-between;
    > span {
      flex: 1;
      line-height: 36px;
      > i {
        color: #008000;
        font-weight: bold;
      }
    }
  }
}
  .lh_num_record {
    display: flex;

    .lh_item {
      display: flex;
      align-items: center;
      margin-left: 0;
      margin-right: 2px;
    }

    .numberft{
      width: 60px;
      height: 60px;
      display: flex;
      line-height: 25px;
      align-items: center;
      justify-content: center;
      background-size: contain;
      background: #ff9800;
      border-radius: 60px;
      color: #fff;
      font-weight: bold;
    }

    .number-1{
      background: #d5d5d5;
    }

    .number-2{
      background: #69ff2c;
    }

    .number-3{
      background: #ffde42;
    }

    .number-4{
      background: #fd3517;
    }

    .numberlhc {
      width: 60px;
      height: 60px;
      display: flex;
      line-height: 25px;
      align-items: center;
      justify-content: center;
      background-size: contain;
    }

    .number-blue {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../static/images/lh/back_blue.png') no-repeat center center;
    }

    .number-green {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../static/images/lh/back_green.png') no-repeat center center;
    }

    .number-red {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../static/images/lh/back_red.png') no-repeat center center;
    }

    .lh_cha {
      display: inline-block;
      margin-right: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/main/card-item/index.vue